import type { Comment } from '@club/types/Comment'

export default {
  toClient (data: unknown): Comment {
    const d = data as Partial<Comment> & {
      author_name?: string
      text?: string
      parent?: { id?: number }
    }
    const comment: Comment = { ...d } as Comment
    comment.author = d.author_name || ''
    comment.email = ''
    comment.comment = d.text || ''
    comment.replies = []
    comment.parent = (d?.parent?.id || null) as number | undefined

    return comment
  }
}
